/**
 * In general JS:
 *   lang.t__("text")
 *
 * In Vue components in HTML
 *   {{ $t__("text") }}
 *
 * In Vue components in JS
 *   this.$t__("text")
 */

let Translator = require('./Translator.js');
let locale = document.querySelector('html').lang;

// __PxnLang - global variable from l10n JS file

if(typeof __PxnLang === 'undefined'){
    __PxnLang = {};
}

window.lang = new Translator(__PxnLang);

Object.defineProperties(window.Vue.prototype, {
    $t__: {
        get() {
            return (original, ...values) =>  window.lang.t__(original, ...values)
        }
    },
    $n__: {
        get() {
            return (original, plural, count, ...values) =>  window.lang.n__(original, plural, count, ...values)
        }
    },
    $c__: {
        get() {
            return (context, original, ...values) =>  window.lang.c__(context, original, ...values)
        }
    },
    $cn__: {
        get() {
            return (context, original, plural, count, ...values) =>  window.lang.cn__(context, original, plural, count, ...values)
        }
    },
});
